import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SuperAdminPanel from "./Components/SuperAdminComp/superadminPanel";
import Login from "./Components/LoginComp/signin";
import Corporate from "./Components/CorporateComp/corporate";
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import PrivateRoute from "./Utils/PrivateRoute";
import { auth, db } from "./Components/LoginComp/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";





const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
        {/* <Route path="/AdminPanel" element={<AdminPanel />} /> */}
   
        <Route
          path="/superadminPanel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <SuperAdminPanel />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporate"
          element={
            <PrivateRoute role="corporate" userRole={userRole}>
              <Corporate />
            </PrivateRoute>
          }
        />


      </Routes>
   
    </Router>

    
  );
};

export default App;